import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../app/axiosInterceptor';
import {
  toRejectPayload,
  setHistoryError,
  clearHistoryError,
  clearAllHistoryErrors
} from './historyError';
import moment from 'moment';
export const reportFuelDrainFill = createAsyncThunk(
  'report/reportFuelDrainFill',
  (
    {
      licensePlates = [],
      licensePlate = '',
      firstTime = '',
      lastTime = '',
      pageSize = 30,
      agencyId = '',
      page = ''
    },
    { rejectWithValue }
  ) => {
    let licensePlateParams = '';
    if (Array.isArray(licensePlates) && licensePlates.length > 0) {
      licensePlateParams = licensePlates
        .map(plate => `licensePlate=${encodeURIComponent(plate)}`)
        .join('&');
    } else if (licensePlate) {
      licensePlateParams = `licensePlate=${encodeURIComponent(licensePlate)}`;
    }
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/oil/filldrain/data?${licensePlateParams}&firstTime=${firstTime}&lastTime=${lastTime}&page=${page}&pageSize=${pageSize}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          reject(rejectWithValue(toRejectPayload(err)));
        });
    });
  }
);

// Báo cáo tổng hợp hoạt động
export const reportActivitySummary = createAsyncThunk(
  'report/reportActivitySummary',
  (
    {
      licensePlates = [],
      licensePlate = '',
      groupID = '',
      firstTime = '',
      lastTime = '',
      pageSize = 30,
      agencyId = '',
      page = ''
    },
    { rejectWithValue }
  ) => {
    // Ưu tiên licensePlates array, fallback về licensePlate string
    const licensePlateValue = Array.isArray(licensePlates) && licensePlates.length > 0
      ? licensePlates
      : (licensePlate || []);

    const params = {
      licensePlate: licensePlateValue,
      groupID: groupID,
      firstTime: firstTime,
      lastTime: lastTime,
      page: page,
      pageSize: pageSize
    };

    const queryString = buildQueryString(params);
    const url = `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/business/active-overview/data?${queryString}`;

    return new Promise((resolve, reject) => {
      axios({
        url: url,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          reject(rejectWithValue(toRejectPayload(err)));
        });
    });
  }
);

// Báo cáo chi tiết hoạt động
export const reportActivityDetail = createAsyncThunk(
  'report/reportActivityDetail',
  (
    {
      licensePlates = [],
      licensePlate = '',
      groupID = '',
      firstTime = '',
      lastTime = '',
      pageSize = 30,
      agencyId = '',
      page = ''
    },
    { rejectWithValue }
  ) => {
    // Ưu tiên licensePlates array, fallback về licensePlate string
    const licensePlateValue = Array.isArray(licensePlates) && licensePlates.length > 0
      ? licensePlates
      : (licensePlate || []);

    const params = {
      licensePlate: licensePlateValue,
      groupID: groupID,
      firstTime: firstTime,
      lastTime: lastTime,
      page: page,
      pageSize: pageSize
    };

    const queryString = buildQueryString(params);
    const url = `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/business/active-detail/data?${queryString}`;

    return new Promise((resolve, reject) => {
      axios({
        url: url,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          reject(rejectWithValue(toRejectPayload(err)));
        });
    });
  }
);

// Báo cáo tổng hợp nhiên liệu
export const reportFuelSummary = createAsyncThunk(
  'report/reportFuelSummary',
  (
    {
      licensePlates = [],
      licensePlate = '',
      groupID = '',
      firstTime = '',
      lastTime = '',
      pageSize = 30,
      agencyId = '',
      page = ''
    },
    { rejectWithValue }
  ) => {
    // Ưu tiên licensePlates array, fallback về licensePlate string
    const licensePlateValue = Array.isArray(licensePlates) && licensePlates.length > 0
      ? licensePlates
      : (licensePlate || []);

    const params = {
      licensePlate: licensePlateValue,
      groupID: groupID,
      firstTime: firstTime,
      lastTime: lastTime,
      page: page,
      pageSize: pageSize
    };

    const queryString = buildQueryString(params);
    const url = `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/oil/summary/data?${queryString}`;

    return new Promise((resolve, reject) => {
      axios({
        url: url,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          reject(rejectWithValue(toRejectPayload(err)));
        });
    });
  }
);

// Báo cáo tiêu hao nhiên liệu
export const reportFuelConsumption = createAsyncThunk(
  'report/reportFuelConsumption',
  (
    {
      licensePlates = [],
      licensePlate = '',
      groupID = '',
      firstTime = '',
      lastTime = '',
      pageSize = 30,
      agencyId = '',
      page = ''
    },
    { rejectWithValue }
  ) => {
    // Ưu tiên licensePlates array, fallback về licensePlate string
    const licensePlateValue = Array.isArray(licensePlates) && licensePlates.length > 0
      ? licensePlates
      : (licensePlate || []);

    const params = {
      licensePlate: licensePlateValue,
      groupID: groupID,
      firstTime: firstTime,
      lastTime: lastTime,
      page: page,
      pageSize: pageSize
    };

    const queryString = buildQueryString(params);
    const url = `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/oil/consumption/data?${queryString}`;

    return new Promise((resolve, reject) => {
      axios({
        url: url,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          reject(rejectWithValue(toRejectPayload(err)));
        });
    });
  }
);

// Báo cáo khu vực giám sát
export const reportMonitoringArea = createAsyncThunk(
  'report/reportMonitoringArea',
  (
    {
      licensePlates = [],
      licensePlate = '',
      groupID = '',
      firstTime = '',
      lastTime = '',
      pageSize = 30,
      agencyId = '',
      page = ''
    },
    { rejectWithValue }
  ) => {
    // Ưu tiên licensePlates array, fallback về licensePlate string
    const licensePlateValue = Array.isArray(licensePlates) && licensePlates.length > 0
      ? licensePlates
      : (licensePlate || []);

    const params = {
      licensePlate: licensePlateValue,
      groupID: groupID,
      firstTime: firstTime,
      lastTime: lastTime,
      page: page,
      pageSize: pageSize
    };

    const queryString = buildQueryString(params);
    const url = `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/business/zone/data?${queryString}`;

    return new Promise((resolve, reject) => {
      axios({
        url: url,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          reject(rejectWithValue(toRejectPayload(err)));
        });
    });
  }
);

// Bao cao tuyen lo trinh 
export const reportBusinessLine = createAsyncThunk(
  'report/reportBusinessLine',
  (
    {
      licensePlates = [],
      checkpointZoneId = [],
      licensePlate = '',
      groupID = '',
      firstTime = '',
      lastTime = '',
      agencyId = '',
      page = '',
      pageSize = 30,
    },
    { rejectWithValue }
  ) => {
    // Ưu tiên licensePlates array, fallback về licensePlate string
    const licensePlateValue = Array.isArray(licensePlates) && licensePlates.length > 0
      ? licensePlates
      : (licensePlate || []);
    const checkpointZoneIdValue = Array.isArray(checkpointZoneId) && checkpointZoneId.length > 0
      ? checkpointZoneId
      : (checkpointZoneId || []);


    const params = {
      licensePlate: licensePlateValue,
      checkpointZoneId: checkpointZoneIdValue,
      groupID: groupID,
      firstTime: firstTime,
      lastTime: lastTime,
      page: page,
      pageSize: pageSize
    };

    const queryString = buildQueryString(params);
    const url = `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/business/safe-zone-trip/data?${queryString}`;

    return new Promise((resolve, reject) => {
      axios({
        url: url,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          reject(rejectWithValue(toRejectPayload(err)));
        });
    });
  }
);

// Bao cao đóng mở cửa
export const reportDoorStatus = createAsyncThunk(
  'report/reportDoorStatus',
  (
    {
      licensePlates = [],
      licensePlate = '',
      groupID = '',
      firstTime = '',
      lastTime = '',
      agencyId = '',
      page = '',
      pageSize = 30,
    },
    { rejectWithValue }
  ) => {
    // Ưu tiên licensePlates array, fallback về licensePlate string
    const licensePlateValue = Array.isArray(licensePlates) && licensePlates.length > 0
      ? licensePlates
      : (licensePlate || []);

    const params = {
      licensePlate: licensePlateValue,
      groupID: groupID,
      firstTime: firstTime,
      lastTime: lastTime,
      page: page,
      pageSize: pageSize
    };

    const queryString = buildQueryString(params);
    const url = `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/business/door/data?${queryString}`;

    return new Promise((resolve, reject) => {
      axios({
        url: url,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          reject(rejectWithValue(toRejectPayload(err)));
        });
    });
  }
);

// Báo cáo động cơ
export const reportEngineStatus = createAsyncThunk(
  'report/reportEngineStatus',
  (
    {
      licensePlates = [],
      licensePlate = '',
      groupID = '',
      firstTime = '',
      lastTime = '',
      agencyId = '',
      page = '',
      pageSize = 30,
    },
    { rejectWithValue }
  ) => {
    // Ưu tiên licensePlates array, fallback về licensePlate string
    const licensePlateValue = Array.isArray(licensePlates) && licensePlates.length > 0
      ? licensePlates
      : (licensePlate || []);

    const params = {
      licensePlate: licensePlateValue,
      groupID: groupID,
      firstTime: firstTime,
      lastTime: lastTime,
      page: page,
      pageSize: pageSize
    };

    const queryString = buildQueryString(params);
    const url = `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/business/engine/data?${queryString}`;

    return new Promise((resolve, reject) => {
      axios({
        url: url,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          reject(rejectWithValue(toRejectPayload(err)));
        });
    });
  }
);

export const reportAirConditionerStatus = createAsyncThunk(
  'report/reportAirConditionerStatus',
  (
    {
      licensePlates = [],
      licensePlate = '',
      groupID = '',
      firstTime = '',
      lastTime = '',
      agencyId = '',
      page = '',
      pageSize = 30,
    },
    { rejectWithValue }
  ) => {
    // Ưu tiên licensePlates array, fallback về licensePlate string
    const licensePlateValue = Array.isArray(licensePlates) && licensePlates.length > 0
      ? licensePlates
      : (licensePlate || []);

    const params = {
      licensePlate: licensePlateValue,
      groupID: groupID,
      firstTime: firstTime,
      lastTime: lastTime,
      page: page,
      pageSize: pageSize
    };

    const queryString = buildQueryString(params);
    const url = `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/business/air-conditioner/data?${queryString}`;

    return new Promise((resolve, reject) => {
      axios({
        url: url,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          reject(rejectWithValue(toRejectPayload(err)));
        });
    });
  }
);

// Helper function: Build query string from params
const buildQueryString = (params) => {
  const queryParams = [];

  Object.keys(params).forEach(key => {
    const value = params[key];
    if (value !== undefined && value !== null && value !== '') {
      if (Array.isArray(value)) {
        if (value.length > 0) {
          // Tạo nhiều param cùng tên cho mỗi item trong array
          value.forEach(item => {
            if (item !== undefined && item !== null && item !== '') {
              queryParams.push(`${key}=${item}`);
            }
          });
        }
      } else {
        queryParams.push(`${key}=${value}`);
      }
    }
  });

  return queryParams.join('&');
};

// Helper function: Download blob as file
const downloadBlob = (blob, fileName) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

// Export báo cáo tổng hợp nhiên liệu ra Excel
export const exportFuelSummaryExcel = createAsyncThunk(
  'report/exportFuelSummaryExcel',
  (
    {
      licensePlates = [],
      firstTime = '',
      lastTime = '',
      agencyId = ''
    },
    { rejectWithValue }
  ) => {
    return new Promise((resolve, reject) => {
      const params = {
        licensePlate: licensePlates,
        firstTime: firstTime,
        lastTime: lastTime
      };

      const queryString = buildQueryString(params);
      const url = `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/oil/summary/excel?${queryString}`;
      const fileName = `Bao_cao_tong_hop_nhien_lieu_${moment().format('DD-MM-YYYY_HH-mm-ss')}.xlsx`;

      axios({
        url: url,
        method: 'GET',
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => {
          downloadBlob(res.data, fileName);
          resolve({ success: true });
        })
        .catch(err => {
          reject(rejectWithValue(toRejectPayload(err)));
        });
    });
  }
);

// Export báo cáo tiêu hao nhiên liệu ra Excel
export const exportFuelConsumptionExcel = createAsyncThunk(
  'report/exportFuelConsumptionExcel',
  (
    {
      licensePlates = [],
      firstTime = '',
      lastTime = '',
      agencyId = ''
    },
    { rejectWithValue }
  ) => {
    return new Promise((resolve, reject) => {
      const params = {
        licensePlate: licensePlates,
        firstTime: firstTime,
        lastTime: lastTime
      };

      const queryString = buildQueryString(params);
      const url = `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/oil/consumption/excel?${queryString}`;
      const fileName = `Bao_cao_tieu_hao_nhien_lieu_${moment().format('DD-MM-YYYY_HH-mm-ss')}.xlsx`;

      axios({
        url: url,
        method: 'GET',
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => {
          downloadBlob(res.data, fileName);
          resolve({ success: true });
        })
        .catch(err => {
          reject(rejectWithValue(toRejectPayload(err)));
        });
    });
  }
);

// Export báo cáo tổng hợp hoạt động ra Excel
export const exportActivitySummaryExcel = createAsyncThunk(
  'report/exportActivitySummaryExcel',
  (
    {
      licensePlates = [],
      firstTime = '',
      lastTime = '',
      agencyId = '',
      groupID = ''
    },
    { rejectWithValue }
  ) => {
    return new Promise((resolve, reject) => {
      const params = {
        licensePlate: licensePlates,
        firstTime: firstTime,
        lastTime: lastTime,
        groupID: groupID
      };

      const queryString = buildQueryString(params);
      const url = `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/business/active-overview/excel?${queryString}`;
      const fileName = `Bao_cao_tong_hop_hoat_dong_${moment().format('DD-MM-YYYY_HH-mm-ss')}.xlsx`;

      axios({
        url: url,
        method: 'GET',
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => {
          downloadBlob(res.data, fileName);
          resolve({ success: true });
        })
        .catch(err => {
          reject(rejectWithValue(toRejectPayload(err)));
        });
    });
  }
);

// Export báo cáo chi tiết hoạt động ra Excel
export const exportActivityDetailExcel = createAsyncThunk(
  'report/exportActivityDetailExcel',
  (
    {
      licensePlates = [],
      firstTime = '',
      lastTime = '',
      agencyId = '',
      groupID = ''
    },
    { rejectWithValue }
  ) => {
    return new Promise((resolve, reject) => {
      const params = {
        licensePlate: licensePlates,
        firstTime: firstTime,
        lastTime: lastTime,
        groupID: groupID
      };

      const queryString = buildQueryString(params);
      const url = `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/business/active-detail/excel?${queryString}`;
      const fileName = `Bao_cao_chi_tiet_hoat_dong_${moment().format('DD-MM-YYYY_HH-mm-ss')}.xlsx`;

      axios({
        url: url,
        method: 'GET',
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => {
          downloadBlob(res.data, fileName);
          resolve({ success: true });
        })
        .catch(err => {
          reject(rejectWithValue(toRejectPayload(err)));
        });
    });
  }
);

// Export báo cáo chi tiết hoạt động ra Excel
export const exportBusinessLineExcel = createAsyncThunk(
  'report/exportBusinessLineExcel',
  (
    {
      licensePlates = [],
      checkpointZoneId = [],
      firstTime = '',
      lastTime = '',
      agencyId = '',
      groupID = ''
    },
    { rejectWithValue }
  ) => {
    return new Promise((resolve, reject) => {
      const params = {
        licensePlate: licensePlates,
        checkpointZoneId: checkpointZoneId,
        firstTime: firstTime,
        lastTime: lastTime,
        groupID: groupID
      };

      const queryString = buildQueryString(params);
      const url = `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/business/safe-zone-trip/excel?${queryString}`;
      const fileName = `Bao_cao_tuyen_lo_trinh_${moment().format('DD-MM-YYYY_HH-mm-ss')}.xlsx`;

      axios({
        url: url,
        method: 'GET',
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => {
          downloadBlob(res.data, fileName);
          resolve({ success: true });
        })
        .catch(err => {
          reject(rejectWithValue(toRejectPayload(err)));
        });
    });
  }
);

// Export báo cáo chi tiết đóng mở cửa ra Excel
export const exportDoorStatusExcel = createAsyncThunk(
  'report/exportDoorStatusExcel',
  (
    {
      licensePlates = [],
      firstTime = '',
      lastTime = '',
      agencyId = ''
    },
    { rejectWithValue }
  ) => {
    return new Promise((resolve, reject) => {
      const params = {
        licensePlate: licensePlates,
        firstTime: firstTime,
        lastTime: lastTime
      };

      const queryString = buildQueryString(params);
      const url = `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/business/door/excel?${queryString}`;
      const fileName = `Bao_cao_dong_mo_cua_${moment().format('DD-MM-YYYY_HH-mm-ss')}.xlsx`;

      axios({
        url: url,
        method: 'GET',
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => {
          downloadBlob(res.data, fileName);
          resolve({ success: true });
        })
        .catch(err => {
          reject(rejectWithValue(toRejectPayload(err)));
        });
    });
  }
);

// Export báo cáo động cơ ra Excel
export const exportEngineStatusExcel = createAsyncThunk(
  'report/exportEngineStatusExcel',
  (
    {
      licensePlates = [],
      firstTime = '',
      lastTime = '',
      agencyId = ''
    },
    { rejectWithValue }
  ) => {
    return new Promise((resolve, reject) => {
      const params = {
        licensePlate: licensePlates,
        firstTime: firstTime,
        lastTime: lastTime
      };

      const queryString = buildQueryString(params);
      const url = `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/business/engine/excel?${queryString}`;
      const fileName = `Bao_cao_dong_co_${moment().format('DD-MM-YYYY_HH-mm-ss')}.xlsx`;

      axios({
        url: url,
        method: 'GET',
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(async res => {
          // Không có dữ liệu -> backend trả 200 nhưng body là JSON lỗi thay vì file
          // nhị phân (xem mục 5 api-bao-cao-dong-co.md) — phải kiểm tra trước khi tải.
          const contentType = res.headers?.['content-type'] || '';
          if (contentType.includes('application/json')) {
            const text = await res.data.text();
            const errorPayload = JSON.parse(text);
            reject(rejectWithValue(errorPayload));
            return;
          }

          downloadBlob(res.data, fileName);
          resolve({ success: true });
        })
        .catch(err => {
          reject(rejectWithValue(toRejectPayload(err)));
        });
    });
  }
);

// Export báo cáo chi tiết điều hòa ra Excel
export const exportAirConditionerStatusExcel = createAsyncThunk(
  'report/exportAirConditionerStatusExcel',
  (
    {
      licensePlates = [],
      firstTime = '',
      lastTime = '',
      agencyId = ''
    },
    { rejectWithValue }
  ) => {
    return new Promise((resolve, reject) => {
      const params = {
        licensePlate: licensePlates,
        firstTime: firstTime,
        lastTime: lastTime
      };

      const queryString = buildQueryString(params);
      const url = `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/business/air-conditioner/excel?${queryString}`;
      const fileName = `Bao_cao_dieu_hoa_${moment().format('DD-MM-YYYY_HH-mm-ss')}.xlsx`;

      axios({
        url: url,
        method: 'GET',
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => {
          downloadBlob(res.data, fileName);
          resolve({ success: true });
        })
        .catch(err => {
          reject(rejectWithValue(toRejectPayload(err)));
        });
    });
  }
);

export const reportDNSlice = createSlice({
  name: 'reportDN',
  initialState: {
    historyErrors: {},
    isLoading: false,
    isExporting: false,
    activitySummaryData: null,
    activityDetailData: null,
    doorStatusData: null,
    engineStatusData: null,
    airConditionerStatusData: null,
    fuelDrainFillData: null,
    fuelSummaryData: null,
    fuelConsumptionData: null,
    monitoringAreaData: null,
    businessLineData: null,

    totalSummary: 0,
    totalDetail: 0,
    totalDoorStatus: 0,
    totalEngineStatus: 0,
    totalAirConditionerStatus: 0,
    totalFuelDrainFill: 0,
    totalFuel: 0,
    totalFuelConsumption: 0,
    totalMonitoringArea: 0,
    totalBusinessLine: 0
  },
  reducers: {
    resetDataScreen: state => {
      clearAllHistoryErrors(state);
      state.activitySummaryData = null;
      state.activityDetailData = null;
      state.doorStatusData = null;
      state.engineStatusData = null;
      state.airConditionerStatusData = null;
      state.fuelDrainFillData = null;
      state.fuelSummaryData = null;
      state.fuelConsumptionData = null;
      state.monitoringAreaData = null;
      state.businessLineData = null;
      state.totalSummary = 0;
      state.totalDetail = 0;
      state.totalDoorStatus = 0;
      state.totalEngineStatus = 0;
      state.totalAirConditionerStatus = 0;
      state.totalFuelDrainFill = 0;
      state.totalFuel = 0;
      state.totalFuelConsumption = 0;
      state.totalMonitoringArea = 0;
      state.totalBusinessLine = 0;
    },
  },
  // reportActivityDetail
  extraReducers: {
    [reportActivitySummary.pending]: state => {
      clearHistoryError(state, 'reportActivitySummary');
      state.isLoading = true;
    },
    [reportActivitySummary.fulfilled]: (state, action) => {
      clearHistoryError(state, 'reportActivitySummary');
      state.activitySummaryData = action.payload.data;
      state.totalSummary = action.payload.total;
      state.isLoading = false;
    },
    [reportActivitySummary.rejected]: (state, action) => {
      setHistoryError(state, 'reportActivitySummary', action);
      state.activitySummaryData = null;
      state.totalSummary = 0;
      state.isLoading = false;
    },

    [reportActivityDetail.pending]: state => {
      clearHistoryError(state, 'reportActivityDetail');
      state.isLoading = true;
    },
    [reportActivityDetail.fulfilled]: (state, action) => {
      clearHistoryError(state, 'reportActivityDetail');
      state.activityDetailData = action.payload.data;
      state.totalDetail = action.payload.total;
      state.isLoading = false;
    },
    [reportActivityDetail.rejected]: (state, action) => {
      setHistoryError(state, 'reportActivityDetail', action);
      state.activityDetailData = null;
      state.totalDetail = 0;
      state.isLoading = false;
    },

    [reportDoorStatus.pending]: state => {
      clearHistoryError(state, 'reportDoorStatus');
      state.isLoading = true;
    },
    [reportDoorStatus.fulfilled]: (state, action) => {
      clearHistoryError(state, 'reportDoorStatus');
      state.doorStatusData = action.payload.data;
      state.totalDoorStatus = action.payload.total;
      state.isLoading = false;
    },
    [reportDoorStatus.rejected]: (state, action) => {
      setHistoryError(state, 'reportDoorStatus', action);
      state.doorStatusData = null;
      state.totalDoorStatus = 0;
      state.isLoading = false;
    },

    [reportEngineStatus.pending]: state => {
      clearHistoryError(state, 'reportEngineStatus');
      state.isLoading = true;
    },
    [reportEngineStatus.fulfilled]: (state, action) => {
      clearHistoryError(state, 'reportEngineStatus');
      state.engineStatusData = action.payload.data;
      state.totalEngineStatus = action.payload.total;
      state.isLoading = false;
    },
    [reportEngineStatus.rejected]: (state, action) => {
      setHistoryError(state, 'reportEngineStatus', action);
      state.engineStatusData = null;
      state.totalEngineStatus = 0;
      state.isLoading = false;
    },

    [reportAirConditionerStatus.pending]: state => {
      clearHistoryError(state, 'reportAirConditionerStatus');
      state.isLoading = true;
    },
    [reportAirConditionerStatus.fulfilled]: (state, action) => {
      clearHistoryError(state, 'reportAirConditionerStatus');
      state.airConditionerStatusData = action.payload.data;
      state.totalAirConditionerStatus = action.payload.total;
      state.isLoading = false;
    },
    [reportAirConditionerStatus.rejected]: (state, action) => {
      setHistoryError(state, 'reportAirConditionerStatus', action);
      state.airConditionerStatusData = null;
      state.totalAirConditionerStatus = 0;
      state.isLoading = false;
    },

    [reportFuelDrainFill.pending]: state => {
      clearHistoryError(state, 'reportFuelDrainFill');
      state.isLoading = true;
    },
    [reportFuelDrainFill.fulfilled]: (state, action) => {
      clearHistoryError(state, 'reportFuelDrainFill');
      state.fuelDrainFillData = action.payload.data;
      state.totalFuelDrainFill = action.payload.total;
      state.isLoading = false;
    },
    [reportFuelDrainFill.rejected]: (state, action) => {
      setHistoryError(state, 'reportFuelDrainFill', action);
      state.fuelDrainFillData = null;
      state.totalFuelDrainFill = 0;
      state.isLoading = false;
    },

    [reportFuelSummary.pending]: state => {
      clearHistoryError(state, 'reportFuelSummary');
      state.isLoading = true;
    },
    [reportFuelSummary.fulfilled]: (state, action) => {
      clearHistoryError(state, 'reportFuelSummary');
      state.fuelSummaryData = action.payload.data;
      state.totalFuel = action.payload.total;
      state.isLoading = false;
    },
    [reportFuelSummary.rejected]: (state, action) => {
      setHistoryError(state, 'reportFuelSummary', action);
      state.fuelSummaryData = null;
      state.totalFuel = 0;
      state.isLoading = false;
    },
    [reportFuelConsumption.pending]: state => {
      clearHistoryError(state, 'reportFuelConsumption');
      state.isLoading = true;
    },
    [reportFuelConsumption.fulfilled]: (state, action) => {
      clearHistoryError(state, 'reportFuelConsumption');
      state.fuelConsumptionData = action.payload.data;
      state.totalFuelConsumption = action.payload.total;
      state.isLoading = false;
    },
    [reportFuelConsumption.rejected]: (state, action) => {
      setHistoryError(state, 'reportFuelConsumption', action);
      state.fuelConsumptionData = null;
      state.totalFuelConsumption = 0;
      state.isLoading = false;
    },
    [reportMonitoringArea.pending]: state => {
      clearHistoryError(state, 'reportMonitoringArea');
      state.isLoading = true;
    },
    [reportMonitoringArea.fulfilled]: (state, action) => {
      clearHistoryError(state, 'reportMonitoringArea');
      state.monitoringAreaData = action.payload.data;
      state.totalMonitoringArea = action.payload.total;
      state.isLoading = false;
    },
    [reportMonitoringArea.rejected]: (state, action) => {
      setHistoryError(state, 'reportMonitoringArea', action);
      state.monitoringAreaData = null;
      state.totalMonitoringArea = 0;
      state.isLoading = false;
    },
    [reportBusinessLine.pending]: state => {
      clearHistoryError(state, 'reportBusinessLine');
      state.isLoading = true;
    },
    [reportBusinessLine.fulfilled]: (state, action) => {
      clearHistoryError(state, 'reportBusinessLine');
      state.businessLineData = action.payload.data;
      state.totalBusinessLine = action.payload.total;
      state.isLoading = false;
    },
    [reportBusinessLine.rejected]: (state, action) => {
      setHistoryError(state, 'reportBusinessLine', action);
      state.businessLineData = null;
      state.totalBusinessLine = 0;
      state.isLoading = false;
    },
    [exportFuelSummaryExcel.pending]: state => {
      state.isExporting = true;
    },
    [exportFuelSummaryExcel.fulfilled]: state => {
      state.isExporting = false;
    },
    [exportFuelSummaryExcel.rejected]: state => {
      state.isExporting = false;
    },
    [exportFuelConsumptionExcel.pending]: state => {
      state.isExporting = true;
    },
    [exportFuelConsumptionExcel.fulfilled]: state => {
      state.isExporting = false;
    },
    [exportFuelConsumptionExcel.rejected]: state => {
      state.isExporting = false;
    },
    [exportActivitySummaryExcel.pending]: state => {
      state.isExporting = true;
    },
    [exportActivitySummaryExcel.fulfilled]: state => {
      state.isExporting = false;
    },
    [exportActivitySummaryExcel.rejected]: state => {
      state.isExporting = false;
    },
    [exportActivityDetailExcel.pending]: state => {
      state.isExporting = true;
    },
    [exportActivityDetailExcel.fulfilled]: state => {
      state.isExporting = false;
    },
    [exportActivityDetailExcel.rejected]: state => {
      state.isExporting = false;
    },
    [exportBusinessLineExcel.pending]: state => {
      state.isExporting = true;
    },
    [exportBusinessLineExcel.fulfilled]: state => {
      state.isExporting = false;
    },
    [exportBusinessLineExcel.rejected]: state => {
      state.isExporting = false;
    },
    [exportDoorStatusExcel.pending]: state => {
      state.isExporting = true;
    },
    [exportDoorStatusExcel.fulfilled]: state => {
      state.isExporting = false;
    },
    [exportDoorStatusExcel.rejected]: state => {
      state.isExporting = false;
    },
    [exportEngineStatusExcel.pending]: state => {
      state.isExporting = true;
    },
    [exportEngineStatusExcel.fulfilled]: state => {
      state.isExporting = false;
    },
    [exportEngineStatusExcel.rejected]: state => {
      state.isExporting = false;
    },
    [exportAirConditionerStatusExcel.pending]: state => {
      state.isExporting = true;
    },
    [exportAirConditionerStatusExcel.fulfilled]: state => {
      state.isExporting = false;
    },
    [exportAirConditionerStatusExcel.rejected]: state => {
      state.isExporting = false;
    },
  }
});

export const { resetDataScreen } = reportDNSlice.actions;

export default reportDNSlice.reducer;
